/** @param {{ userId?: number|null, isViewAsActive?: boolean, viewAsUserId?: number|null }} ctx */
export function personalHubViewerCacheKey(ctx) {
  const uid = ctx.userId ?? 0;
  const vid = ctx.isViewAsActive ? (ctx.viewAsUserId ?? 0) : 0;
  return `u:${uid}:v:${vid}`;
}
